import * as firebase from 'firebase';
import 'firebase/messaging';
import 'firebase/analytics';

const initializedFirebaseApp = firebase.initializeApp({
  // Project Settings => Add Firebase to your web app
  apiKey: 'AIzaSyCxMSQx3fX99RP9jZ3NRxcd5tW5ylcaQCY',
  authDomain: 'zeero-e0f92.firebaseapp.com',
  projectId: 'zeero-e0f92',
  storageBucket: 'zeero-e0f92.appspot.com',
  messagingSenderId: '987268622988',
  appId: '1:987268622988:web:3e55c17ae03a60ae2fa9a9',
  measurementId: 'G-4SYL59F3CQ',
});

let messaging = null;
if (firebase.messaging.isSupported()) {
  messaging = initializedFirebaseApp.messaging();
}

const analytics = {logEvent :()=>{} , setUserProperties : ()=>{} , getAppInstanceId : ()=>{}}

export {messaging};
export {analytics};
